// extracted by mini-css-extract-plugin
export var option = "SelectInput-module--option--2wsN3";